import React from "react";

import { capitalize } from "../../../utilities";

const sponsorshipLabels = [
  "sponsored",
  "unsponsored",
  "Ad",
  "organic",
  "licensed",
];

export default ({ sponsorship }) => (
  <div className="sponsorship-label">
    {sponsorshipLabels.includes(sponsorship) && capitalize(sponsorship)}
  </div>
);
